import React, { useEffect, useState } from "react";
import { FooterWithCookieConsentProps } from "../types/FooterWithCookieConsentProps";
import { IdwalFooter } from "../IdwalFooter/IdwalFooter";
import { CookieConsentDialog } from "../CookieConsentDialog/CookieConsentDialog";
import { CookieConsent } from "../CookieConsent/CookieConsent";

export const FooterWithCookieConsent = ({
    termsAndConditionsLink,
    dataPrivacyLink,
    dataPrivacyLinkText,
    enableCookies,
    cookieUtils
}: FooterWithCookieConsentProps) => {
    const [showCookieConsentDialog, setShowCookieConsentDialog] =
        useState(false);
    const storedConsentCookies = cookieUtils.readCookiePreferences();

    const noCookiesSet =
        storedConsentCookies?.all === undefined &&
        storedConsentCookies?.nonEssential === undefined &&
        storedConsentCookies?.analytics === undefined &&
        !window.location.pathname.includes("/logout");

    const [cookiePopupVisible, setCookiePopupVisible] = useState<boolean>();
    const [analyticsCookiesEnabled, setAnalyticsCookiesEnabled] =
        useState(false);

    useEffect(() => {
        setAnalyticsCookiesEnabled(Boolean(storedConsentCookies?.analytics));
        setCookiePopupVisible(noCookiesSet);
    }, [storedConsentCookies]);

    return (
        <>
            <IdwalFooter
                termsAndConditionsLink={termsAndConditionsLink}
                showCookieConsent={enableCookies}
                onClickCookiePolicy={() => setShowCookieConsentDialog(true)}
            />
            {enableCookies ? (
                <>
                    <CookieConsentDialog
                        onToggleAnalyticsCookies={() => {
                            cookieUtils.acceptAnalytics(
                                !analyticsCookiesEnabled
                            );
                            setAnalyticsCookiesEnabled(
                                !analyticsCookiesEnabled
                            );
                        }}
                        analyticCookiesEnabled={analyticsCookiesEnabled}
                        visible={showCookieConsentDialog}
                        dataPrivacyLink={dataPrivacyLink}
                        dataPrivacyLinkText={dataPrivacyLinkText}
                        onHide={() => setShowCookieConsentDialog(false)}
                    />
                    <CookieConsent
                        onClickCookiePolicy={() =>
                            setShowCookieConsentDialog(true)
                        }
                        onReject={() => {
                            setCookiePopupVisible(false);
                            cookieUtils.rejectAll();
                        }}
                        onAccept={() => {
                            setCookiePopupVisible(false);
                            cookieUtils.acceptAll();
                        }}
                        onHide={() => {
                            setCookiePopupVisible(false);
                        }}
                        visible={Boolean(cookiePopupVisible)}
                    />
                </>
            ) : null}
        </>
    );
};
